// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__1lP6I","marketplaceStroke":"IconEmailAttention_marketplaceStroke__O5vp6","attentionStroke":"IconEmailAttention_attentionStroke__2dOLz"};